import { render } from "./ClientGrid.vue?vue&type=template&id=553c5bb7"
import script from "./ClientGrid.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientGrid.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script